// extracted by mini-css-extract-plugin
export default {"b-icon-warning":"Checkbox_style_b-icon-warning__cI2Zt","checkbox":"Checkbox_style_checkbox__ewOq2","rotate":"Checkbox_style_rotate__fYurr"};